import React from 'react';
import PhoneService from './PhoneService';
import { GOLDEN_VALLEY_PHONE } from '../data/localSeoContent';

const PhoneGoldenValley: React.FC = () => (
  <PhoneService
    city="Golden Valley"
    heroTitle={
      <>
        Phone Service in
        <br />
        <span className="text-white">Golden Valley, Arizona</span>
      </>
    }
    heroSubtitle="Reliable home and business phone service in Golden Valley — unlimited calling, number porting, and local Airmax support."
    localSeo={GOLDEN_VALLEY_PHONE}
  />
);

export default PhoneGoldenValley;
